import type { StipulationStatusDisplay } from "../../../components/ui/statusBadge";

// Maps the BFF's raw stipulation status codes to the panel's display buckets.
// Keyed by upper-cased code so casing differences from the server don't matter.
// Unknown codes return undefined; the panel then renders the raw string without
// a status color (rather than guessing a bucket).
const STATUS_DISPLAY: Record<string, StipulationStatusDisplay> = {
  ACTIVE: "open",
  OPEN: "open",
  COMPLETED: "closed",
  CLOSED: "closed",
  WAIVED: "waived",
  EXCEPTION: "exception",
  REOPENED: "reopened",
};

/**
 * Maps a raw BFF status code to a display bucket.
 * @param {string} [raw] - The raw `StipulationListItem.status` value.
 * @returns {StipulationStatusDisplay | undefined} The display bucket, or undefined when unknown.
 */
export function toStatusDisplay(raw?: string): StipulationStatusDisplay | undefined {
  if (!raw) {
    return undefined;
  }
  return STATUS_DISPLAY[raw.toUpperCase()];
}
